import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import css from './FormElement.css';

const FormElement = ({
    label = '',
    placeholder = '',
    optionalText = '',
    value = '',
    valid = true,
    dirty = false,
    disabled = false,
    errorMessage = '',
    maxLength = 100,
    onChange = () => {},
    onBlur = () => {},
    className = '',
}) => (
    <div className={classNames(css.formElementContainer, className, { [css.invalid]: !valid && dirty })}>
        <div className={css.formElementLabel}>
            {label} {optionalText ? `(${optionalText})` : ''}
        </div>
        <input
            disabled={disabled}
            value={value}
            type="text"
            placeholder={placeholder}
            className={css.formElementInput}
            onChange={e => onChange(e.target.value)}
            onBlur={e => onBlur(e.target.value)}
            maxLength={maxLength}
        />
        {dirty && !valid && errorMessage && <div className={css.formElementErrorMessage}>{errorMessage}</div>}
    </div>
);

FormElement.propTypes = {
    label: PropTypes.string,
    placeholder: PropTypes.string,
    optionalText: PropTypes.string,
    value: PropTypes.string,
    valid: PropTypes.bool,
    dirty: PropTypes.bool,
    disabled: PropTypes.bool,
    errorMessage: PropTypes.string,
    maxLength: PropTypes.number,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    className: PropTypes.string,
};

export default FormElement;
